export type DeadAirMetricsExcludeConditions = {
	isAIFC: boolean;
	isDeepResearch: boolean;
};

/**
 * Determines whether dead air metrics should be excluded based on the current stream conditions.
 */
export const shouldExcludeDeadAirMetrics = (
	conditions: DeadAirMetricsExcludeConditions,
): boolean => {
	return (
		// AIFC: Not tracking the full extent of AIFC flow. Visual changes in the staging area
		// (where content is created/modified) are not instrumented, resulting in incomplete metrics.
		conditions.isAIFC ||
		// Deep Research: Has a separate research steps view/handler not tracked by ViewDeadAirTracker.
		// Requires additional instrumentation work to capture accurately.
		conditions.isDeepResearch
	);
};
